// extracted by mini-css-extract-plugin
export default {"sizeButtons":"tttD0E","sizeButton":"wqOoZJ","sizeLabels":"zfyJQj","sizeLabel":"G6IfTk"};